export default "__VITE_ASSET__CkbUeC57__"